import { useMemo } from 'react';
import { useSurgeons } from 'api/hooks/useSurgeons';
import { NamedSelectOption } from 'components/DropDown/ValidatingSelect';
import { useSurgeonsFilters } from './useSurgeonsFilters';

type Props = { active?: boolean; removeDuplicates?: boolean };

const useSurgeonSelectOptions = (props?: Props) => {
  const surgeonsFilters = useSurgeonsFilters()[0];
  const active = props?.active == null ? true : props.active;

  const { data: surgeons, isLoading: surgeonsLoading } = useSurgeons({ ...surgeonsFilters, active });

  const surgeonOptions = useMemo<NamedSelectOption[]>(() => {
    const surgeonOptionsUnique = (surgeons?.surgeons || []).reduce<Record<string, NamedSelectOption>>(
      (acc, surgeon) => {
        let name = surgeon.name;

        if (props?.removeDuplicates && acc[name]) {
          return acc;
        }

        let num = 1;
        while (acc[name]) {
          name = `${surgeon.name} (${++num})`;
        }
        acc[name] = {
          id: surgeon.id,
          label: name,
          name: surgeon.name,
        };
        return acc;
      },
      {},
    );
    return Object.values(surgeonOptionsUnique);
  }, [props?.removeDuplicates, surgeons?.surgeons]);

  return { surgeons: surgeons?.surgeons, surgeonsLoading, surgeonOptions };
};

export default useSurgeonSelectOptions;
